<template>
  <user-roles />
</template>

<script>
import userRoles from "@/components/user-roles/user-roles";

export default {
  components: {
    userRoles
  }
};
</script>

<style></style>
